import { ca } from '@cian/analytics';

import { TPageType } from '../../../../types/page';
import { pageTypeToAnalyticsCategory } from '../../../../utils/pageType';

const MOBWEB_BURGER_MORTGAGE_APP_EXTRA = {
  trap_type: 'mobweb_burger_mortgage_app',
  bannerName: 'Ипотечная анкета',
  trapid: 'Ипотечная анкета',
} as const;

function trackMobwebBurgerMortgageAppTrap(action: 'click_sopr' | 'show_sopr') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action,
    label: 'mortgage_button',
    page: {
      extra: MOBWEB_BURGER_MORTGAGE_APP_EXTRA,
    },
  });
}

function closureTrackMobwebBurgerMortgageAppShow() {
  let wasEventSent = false;

  return () => {
    if (wasEventSent) {
      return;
    }

    wasEventSent = true;
    trackMobwebBurgerMortgageAppTrap('show_sopr');
  };
}

/** Показ пункта «Ипотечная анкета» в бургер-меню; не более одного события за жизненный цикл страницы */
export const trackMobwebBurgerMortgageAppShow = closureTrackMobwebBurgerMortgageAppShow();

export function trackMobwebBurgerMortgageAppClick() {
  trackMobwebBurgerMortgageAppTrap('click_sopr');
}

/** Сервисы с category из pageType и action: top_menu */
const TOP_MENU_SERVICES = new Set(['favorites', 'add_adv']);

/** Сервисы с category: Mob_menu и action: click */
const MOB_MENU_CLICK_SERVICES = new Set([
  'EstateCalculator',
  'my_home',
  'messages',
  'new_search',
  'help_center',
  'report_bug',
  'mortgage_calculator',
  'ask_specialist_help',
  'buy_or_rent',
  'analytics_to_business',
]);

export function trackServiceClick(pageType: TPageType, service: string) {
  if (service === 'mortgage_form') {
    trackMobwebBurgerMortgageAppClick();

    return;
  }

  const category = MOB_MENU_CLICK_SERVICES.has(service) ? 'Mob_menu' : pageTypeToAnalyticsCategory(pageType);

  const action = TOP_MENU_SERVICES.has(service) ? 'top_menu' : 'click';

  ca('eventSite', {
    name: 'oldevent',
    category,
    action,
    label: service,
  });
}
